import { createBrowserHistory } from "history"

const history = createBrowserHistory()

const dispatchMaintenanceMode = () => {
  history.push("/maintenance")
  window.location.reload()
}
export default dispatchMaintenanceMode
